import React, { useEffect, useState } from 'react';
import { FileText, ChevronDown } from 'lucide-react';
import { regolamento as regolamentoMock } from '../data/mock';
import SocialShare from '../components/SocialShare';
import { api } from '../api/client';
import { useSiteText } from '../hooks/useSiteText';

export default function Regolamento() {
  const [open, setOpen] = useState(0);
  const [regolamento, setRegolamento] = useState(regolamentoMock);
  const title = useSiteText('regolamento.title', 'Regolamento');
  const subtitle = useSiteText('regolamento.subtitle', 'Le regole del XIV Memorial Eugenio Abbro. Consulta gli articoli per conoscere tutti i dettagli del torneo.');

  useEffect(() => {
    let alive = true;
    api.getRegolamentoFull().then((rows) => {
      if (!alive) return;
      if (Array.isArray(rows) && rows.length > 0) {
        setRegolamento(rows.map((r) => ({ titolo: r.titolo || '', testo: r.testo || '' })));
      }
    }).catch(() => { /* fallback su mock */ });
    return () => { alive = false; };
  }, []);

  return (
    <div className="bg-navy min-h-screen">
      <section className="relative py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-dark to-navy"></div>
        <div className="relative max-w-5xl mx-auto px-4 lg:px-8 text-center">
          <FileText size={48} className="text-pink-brand mx-auto mb-4" />
          <h1 className="font-brand text-5xl md:text-6xl font-bold text-white mb-4">{title}</h1>
          <div className="w-24 h-1 bg-pink-brand mx-auto rounded"></div>
          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            {subtitle}
          </p>
          <div className="mt-6 flex justify-center">
            <SocialShare title="Regolamento XIV Memorial Eugenio Abbro" />
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 space-y-3">
          {regolamento.map((art, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="glass-card overflow-hidden">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between p-5 text-left"
                >
                  <div className="flex items-center gap-4">
                    <span className="w-10 h-10 rounded-lg bg-pink-brand text-white font-bold flex items-center justify-center flex-shrink-0">
                      {i + 1}
                    </span>
                    <h3 className="text-white font-bold text-base lg:text-lg">{art.titolo}</h3>
                  </div>
                  <ChevronDown
                    size={22}
                    className={`text-pink-brand transition-transform flex-shrink-0 ml-3 ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pt-0 animate-fade-in">
                    <div className="pl-14 text-white/85 leading-relaxed whitespace-pre-wrap">{art.testo}</div>
                  </div>
                )}
              </div>
            );
          })}
          {regolamento.length === 0 && (
            <div className="glass-card p-8 text-center text-white/60">Nessun articolo del regolamento ancora pubblicato.</div>
          )}
        </div>
      </section>
    </div>
  );
}
